export default __webpack_public_path__ + "static/media/Seccion_promos_pasada_2_agosto_ms.692dcd6d.webp";